const equipmentmodels = {
	title: "Equipment Models",
	stitle: "Equipment Model",
	new_title: "New Equipment Model",
	edit_title: "Edit Equipment Model: {name}",
	list_title: "List of Equipment Models",
	list_subtitle: "Manage equipment models",
	id: "ID",
	name: "Name",
	status: "Status",
	reference_id: "Reference ID",
};
export default equipmentmodels;